<script setup>
import RiskFrameworkEditor from '@/views/quality/risk/governance/RiskFrameworkEditor.vue'
import RiskReportList from '@/views/quality/risk/governance/RiskReportList.vue'
import RiskReportView from '@/views/quality/risk/governance/RiskReportView.vue'

// unplugin-vue-router derives the route name from the file path
// (`app-quality-risk-governance`) — see src/pages/app/quality/risk/[id].vue
// for the same convention (meta.name is a CASL subject key, not a route name,
// so it is intentionally absent here). The permission guard only reads
// meta.subject/meta.action (src/plugins/2.router/guards.js).
definePage({
  meta: {
    subject: 'risk.menu',
    action: 'governance',
  },
})

const currentTab = ref('framework')

// The selected report replaces the list in-place rather than opening in a
// dialog: the report view is printed to produce the written board report, and
// an overlay does not print as a page.
const selectedReportId = ref(null)

const openReport = id => {
  selectedReportId.value = id
}

const closeReport = () => {
  selectedReportId.value = null
}
</script>

<template>
  <section>
    <VTabs
      v-model="currentTab"
      class="mb-6 no-print"
    >
      <VTab value="framework">
        <VIcon
          icon="tabler-shield-check"
          size="20"
          class="me-2"
        />
        Framework
      </VTab>
      <VTab value="reports">
        <VIcon
          icon="tabler-report"
          size="20"
          class="me-2"
        />
        Reports
      </VTab>
    </VTabs>

    <VWindow
      v-model="currentTab"
      class="disable-tab-transition"
    >
      <VWindowItem value="framework">
        <RiskFrameworkEditor />
      </VWindowItem>

      <VWindowItem value="reports">
        <RiskReportView
          v-if="selectedReportId"
          :report-id="selectedReportId"
          @back="closeReport"
        />
        <RiskReportList
          v-else
          @view="openReport"
        />
      </VWindowItem>
    </VWindow>
  </section>
</template>
